module.exports = __webpack_public_path__ + "img/4.0cef6ff1.png";